import $ from 'jquery';
import Headroom from 'headroom.js';
import debounce from 'lodash/debounce';
import throttle from 'lodash/throttle';
import {requestAnimationTimeout} from './requestAnimationTimeout';

class TopBar {
    constructor($topBar) {
        if ($('.header-fixed').length) {
            this.init($topBar);
            this.events();
        }
    }

    init($topBar) {
        this.$win = $(window);
        this.$topBar = $topBar;
        this.$body = $('body');

        this.pos = window.pageYOffset || document.documentElement.scrollTop;
        this.fixed = false;

        this.isTop = this.pos === 0;

        let headroom = new Headroom(this.$topBar[0]);

        headroom.init();
    }

    events() {
        this.$win.on('resize', this.getPositions.bind(this));
        window.addEventListener('scroll', debounce(this.toggleTopBar.bind(this), 30), {passive: true});

        this.$win.scroll();
    }

    getPositions() {
        this.barHeight = this.$topBar.outerHeight();

        // top bar position when on top
        this.$topBar.addClass('top');
        this.fixedPos = this.$topBar.offset().top;
        this.$topBar.toggleClass('top', this.isTop);

        this.outPos = this.fixedPos + this.barHeight;
        this.toggleTopBar();
    }

    toggleTopBar() {
        let oldPos = this.pos/*,
            delta = 10*/;

        this.pos = window.pageYOffset || document.documentElement.scrollTop;

        /*if (Math.abs(oldPos - this.pos) <= delta)
            return;*/

        if (this.pos <= oldPos) { // scroll up
            if (this.pos <= this.fixedPos) {
                this.fixed = false;
                this.isTop = true;
                this.$topBar.removeClass('fixed').addClass('top');
            } else {
                this.isTop = false;
                this.$topBar.removeClass('top');
            }
        } else if (this.pos > this.outPos) { // scroll down
            if (!this.fixed) {
                this.fixed = true;
                this.isTop = false;
                this.$topBar.removeClass('top').addClass('fixed no-animation');

                requestAnimationTimeout(() => { this.$topBar.removeClass('no-animation'); }, 100);
            }
        }

        this.oldPos = oldPos;
    }
}

export default TopBar;
